export default __webpack_public_path__ + "static/media/forbidden_data.c3ead91b.png";